import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './GlobalLogin.css';
import { AuthSetupShell, IconMail, IconArrow, IconKey } from './authShared';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();

      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.message || 'Something went wrong');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <AuthSetupShell>
        <div className="gl-auth__badge">
          <IconMail />
        </div>
        <header className="gl-auth__card-head">
          <h2>Password reset</h2>
          <p>Check your email</p>
        </header>
        <p className="gl-auth__hint">
          If an account exists with that email, a password reset link has been sent. Please check your inbox and spam
          folder.
        </p>
        <Link to="/login" className="gl-auth__submit" style={{ textDecoration: 'none' }}>
          <span>Back to login</span>
          <IconArrow />
        </Link>
      </AuthSetupShell>
    );
  }

  return (
    <AuthSetupShell>
      <div className="gl-auth__badge">
        <IconKey />
      </div>
      <header className="gl-auth__card-head">
        <h2>Password reset</h2>
        <p>Forgot your password?</p>
      </header>
      <p className="gl-auth__hint">
        Enter your account email and we'll send you a link to reset your password.
      </p>
      <form className="gl-auth__form" onSubmit={handleSubmit}>
        <div className="gl-auth__field">
          <label className="gl-auth__label" htmlFor="fp-email">
            Email
          </label>
          <div className="gl-auth__input-wrap">
            <span className="gl-auth__input-icon" aria-hidden>
              <IconMail />
            </span>
            <input
              type="email"
              id="fp-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="gl-auth__input"
              required
              autoComplete="email"
            />
          </div>
        </div>

        {error ? <div className="gl-auth__error">{error}</div> : null}

        <button type="submit" className="gl-auth__submit" disabled={loading}>
          <span>{loading ? 'Sending…' : 'Send reset link'}</span>
          {!loading ? <IconArrow /> : null}
        </button>

        <div className="customer-access-link">
          <Link to="/login">Back to login</Link>
        </div>
      </form>
    </AuthSetupShell>
  );
};

export default ForgotPassword;
